// react
import React from "react";

import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Icon from "../../components/Icon";
import Spacer from "../../components/Spacer";
import Typography from "../../components/Text";
import Tooltip from "../../components/Tooltip";
// components
import InputProxy from "./Input";

// props
import PropTypes from "../../lib/prop-types";

export default class CreateFormContainer extends React.PureComponent {
	/*
        I use this design on many pages so I figured I should componentize
        it so it's reusable.

        is componentize a word?
    */

	static propTypes = {
		formIcon: PropTypes.array,
		formDescription: PropTypes.string,
		formName: PropTypes.string,
		inputs: PropTypes.arrayOf(PropTypes.object),
		actions: PropTypes.arrayOf(PropTypes.element),
	};

	static defaultProps = {
		formIcon: "",
		formName: "",
		actions: [],
		inputs: [],
		formDescription: null,
	};

	render() {
		const { inputs, actions, formIcon, formName, formDescription } = this.props;

		return (
			<section className="cn-create-form">
				<section className="head-content">
					<Icon type="fa5" name={formIcon} size="1x" />
					<Typography weight="semi-bold" size="sub-heading">
						{formName}
					</Typography>
					{formDescription ? (
						<Typography size="paragraph-3" weight="regular" className="form-description">
							{formDescription}
						</Typography>
					) : (
						<div />
					)}
				</section>

				<section className="form-inputs-container">
					{inputs.map((item) => {
						if (item === null) {
							return null;
						}

						const canEdit = item.isEditable || item.isEditable === undefined;
						/*
                            For checkboxes, put the label and input inline.
                        */

						if (item._type === "checkbox") {
							// eslint-disable-line no-underscore-dangle
							return (
								<div key={item.key} className="input-container checkbox-input-container">
									<InputProxy {...item} />
									<div className="checkbox-label-container">
										<span className="primary-label">
											<label htmlFor={item.key} className="primary-label-container">
												<Typography size="paragraph-3" weight="semi-bold">
													{item.label}
												</Typography>
												{item.info ? (
													<Typography size="extra-small" weight="regular" color="neutral-7">
														<Tooltip
															title={item.info.title}
															message={item.info.message}
															placement="right"
														>
															<FontAwesomeIcon icon={faCircleInfo} />
														</Tooltip>
													</Typography>
												) : null}
												{item.showIsOptional ? (
													<div className="optional-tag">( optional )</div>
												) : null}
											</label>
										</span>
									</div>
								</div>
							);
						}

						return (
							<div key={item.key} className="input-container">
								<div className="primary-label">
									<label htmlFor={item.key} className="primary-label-container">
										<Typography size="paragraph-3" weight="semi-bold">
											{item.label}
										</Typography>
										{item.info ? (
											<Typography size="extra-small" weight="regular" color="neutral-7">
												<Tooltip
													title={item.info.title}
													message={item.info.message}
													placement="right"
												>
													<FontAwesomeIcon icon={faCircleInfo} />
												</Tooltip>
											</Typography>
										) : null}
										{item.showIsOptional ? <div className="optional-tag">( optional )</div> : null}
									</label>
								</div>
								{item.secondaryLabel ? (
									<div className="secondary-label">{item.secondaryLabel}</div>
								) : null}
								<Spacer height={1} />
								{canEdit ? (
									<InputProxy {...item} />
								) : (
									<div className="not-editable-value">{item.value}</div>
								)}
							</div>
						);
					})}
				</section>

				{actions.length > 0 ? <section className="action-buttons-container">{actions}</section> : <div />}
			</section>
		);
	}
}
